export default {
  tabs: {
    all: {
      en: 'All',
      ru: 'Все',
      fr: 'Tous',
      es: 'All',
      pt: 'Todos',
      de: 'Alle',
      zh: '所有',
    },
    deposits: {
      en: 'Deposits',
      ru: 'Пополнения',
      fr: 'Date du dépôt',
      es: 'Depósitos',
      pt: 'Sinais',
      de: 'Anzahlungen',
      zh: '存款',
    },
  },
  emptyDeposits: {
    en: 'The Vaults with your deposits will appear here',
    ru: 'Хранилища, в которых у вас есть депозиты, появятся здесь',
    fr: 'Les coffres-forts dans lesquels vous avez des dépôts apparaîtront ici',
    es: 'Las bóvedas en las que tienes depósitos aparecerán aquí',
    pt: 'Os Vaults em que você tem depósitos aparecerão aqui',
    de: 'Die Tresore, in denen Sie Einlagen haben, werden hier angezeigt',
    zh: '您存入的保管库将显示在此处',
  },
  emptySearch: {
    en: 'No matching Vaults',
    ru: 'Нет подходящих хранилищ',
    fr: 'Aucun coffre-fort correspondant',
    es: 'No hay bóvedas coincidentes',
    pt: 'Sem Vaults correspondentes',
    de: 'Keine passenden Tresore',
    zh: '没有匹配的保管库',
  },
}
